import PaginatedList from '@theme/paginated-list';

const ARTICLE_SECTION_ID = 'main-blog-post';

function shouldRepairBlogArticlePage({ pathname, hasBlogPostsList, hasArticleFallback }) {
  if (!hasBlogPostsList || hasArticleFallback) return false;

  const segments = String(pathname || '')
    .split('/')
    .filter(Boolean);

  const blogsIndex = segments.indexOf('blogs');
  if (blogsIndex === -1) return false;

  const articleHandle = segments[blogsIndex + 2];
  const routeTail = segments[blogsIndex + 3];

  return Boolean(articleHandle) && articleHandle !== 'tagged' && !routeTail;
}

function buildArticleSectionUrl(url) {
  const sectionUrl = new URL(url);
  sectionUrl.searchParams.set('section_id', ARTICLE_SECTION_ID);
  return sectionUrl.toString();
}

export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback?.();

    if (this.dataset.ycArticleRepairMounted === 'true') return;
    this.dataset.ycArticleRepairMounted = 'true';

    this.repairArticleRoute().catch(() => {});
  }

  async repairArticleRoute() {
    if (
      !shouldRepairBlogArticlePage({
        pathname: window.location.pathname,
        hasBlogPostsList: true,
        hasArticleFallback: document.querySelector('[data-testid="blog-article-fallback"]') !== null,
      })
    ) {
      return;
    }

    const sectionRoot = this.closest('.shopify-section');
    if (!sectionRoot) return;

    const sectionUrl = buildArticleSectionUrl(window.location.href);
    const response = await fetch(sectionUrl, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });

    if (!response.ok) return;

    const html = await response.text();
    if (!html || html.includes('<blog-posts-list')) return;

    const container = document.createElement('div');
    container.innerHTML = html.trim();

    const replacement = container.querySelector('.shopify-section');
    if (!replacement) return;

    const mainContent = document.querySelector('#MainContent');
    if (mainContent instanceof HTMLElement) {
      mainContent.dataset.template = 'article';
    }

    sectionRoot.replaceWith(replacement);
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
